import { Box } from '@mui/joy';
import { useTheme } from '@mui/joy/styles';
import { CustomCellRendererProps } from 'ag-grid-react';

import { DEFAULT_DETAIL_ROW_HEIGHT } from 'core/constants';
import { PartBomDetails, PartBomDetailsTab } from 'partBoms/components/PartBomDetails';
import { PartBomType } from 'partBoms/enums';

export const DetailPartBomItem = ({ data }: CustomCellRendererProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        padding: 1.5,
        height: DEFAULT_DETAIL_ROW_HEIGHT,
        backgroundColor: theme.palette.background.level1,
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          padding: '12px 12px 0',
          backgroundColor: theme.palette.background.body,
          borderRadius: 6,
        }}
      >
        <PartBomDetails
          partBom={data.partArr}
          defaultTab={PartBomDetailsTab.ITEM_LIST}
          inline
          isEditable={data.partArr?.bomType !== PartBomType.STANDARD}
        />
      </Box>
    </Box>
  );
};
